export const DOC_CARD_STYLE = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(201,168,76,0.25)",
  borderRadius: "14px",
  padding: "20px",
  marginBottom: "16px",
};

export const DOC_SECTION_TITLE = {
  fontWeight: 700,
  fontSize: "18px",
  color: "#c9a84c",
  marginBottom: "14px",
  letterSpacing: "0.02em",
};

export const DOC_FIELD_ROW = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  gap: "16px",
  marginBottom: "10px",
  fontSize: "14px",
};

export const DOC_FIELD_LABEL = {
  opacity: 0.65,
  flexShrink: 0,
};

export const DOC_FIELD_VALUE = {
  fontWeight: 600,
  textAlign: "right",
};

export const DOC_LINE_ROW = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "8px",
  fontSize: "14px",
};

export const DOC_LINE_ROW_EMPHASIS = {
  ...DOC_LINE_ROW,
  fontWeight: 700,
  fontSize: "15px",
  color: "#c9a84c",
  marginTop: "8px",
  paddingTop: "10px",
  borderTop: "1px solid rgba(201,168,76,0.25)",
};

export const DOC_ITEM_BLOCK = {
  padding: "12px 14px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid rgba(201,168,76,0.15)",
  background: "rgba(0,0,0,0.12)",
};

export const DOC_ITEM_TITLE = {
  fontWeight: 600,
  fontSize: "14px",
  color: "#e8dcc0",
};

export const DOC_ITEM_META = {
  opacity: 0.72,
  fontSize: "13px",
  marginTop: "4px",
  lineHeight: 1.45,
};

export const DOC_ITEM_AMOUNT = {
  fontWeight: 600,
  fontSize: "14px",
  color: "#c9a84c",
  marginTop: "6px",
};
